/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import Guid from "devextreme/core/guid";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { SelectBox } from "devextreme-react";

import { useDispatch, useSelector } from "react-redux";
import { responseEmployee } from "../../redux/reducers";
import { showEmployee } from "../../redux/actions";
import { axios } from "../../common";
import { useAuth } from "../../contexts/auth";
import UsingIntl from "../../services/using_intl";
import { useScreenSize } from "../../utils/media-query";

import PopupConfig from "../../common/popup";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

const MIDDLE = {
  Oid: "5f39d933-ba6b-436b-92ba-2e8548c48591",
  NavigateState: true,
  ReadState: true,
  WriteState: true,
  CreateState: true,
  DeleteState: true,
  ImportState: true,
  ExportState: true,
  ApproveState: true,
  Remarks: null,
  Navigation: {
    Oid: "94010040-abb7-4c90-9278-cfad6d948ef5",
    ItemCode: "P0014",
    text: "Leave Registration",
    textVi: "Đăng ký nghỉ",
    textJa: null,
    path: "/leave-registration/list",
    icon: null,
    Remarks: null,
    Order: 0,
    IsActive: true,
  },
  Role: {
    Oid: "2526b40a-72dc-455f-ad13-d924135ac48d",
    RoleName: "Administrator",
    PermissionPolicy: 2,
    Remarks: "",
    IsActive: true,
  },
};

export default function HomeBVN() {
  const { user, signIn } = useAuth();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const { employee } = useSelector(responseEmployee);
  const dispatch = useDispatch();
  const history = useHistory();
  const [count, setCount] = useState({});
  const { isSmall, isXSmall } = useScreenSize();
  const [employeeOid, setEmployeeOid] = React.useState(
    new Guid(user.EmployeeOid)
  );
  useEffect(() => {
    if (user.UserName === "powerfuladmin") {
      dispatch(showEmployee());
      handleOpenPopup();
    }
  }, [user, dispatch]);

  useEffect(() => {
    UsingIntl("P0002");
  }, []);
  function gridBoxDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }

  useEffect(() => {
    const getRequestItem = async () => {
      const { data } = await axios.get(
        `PendingHomeSetting(${user?.EmployeeOid})`, {
          headers: {
            MappedState: 1,
          },
        }
      );
      setCount(data[0]?.PendingApprove);
    };
    getRequestItem();
  }, []);
  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={true}
      >
        <SelectBox
          valueExpr="Oid"
          dataSource={employee}
          value={employeeOid}
          displayExpr={gridBoxDisplayExpr}
          itemRender={gridBoxDisplayExpr}
          onValueChanged={(e) => {
            setEmployeeOid(e.value);
          }}
          searchEnabled={true}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={() => {
            signIn(user.UserName, user.Password, employeeOid);
          }}
          options={{
            icon: "check",
            type: "default",
            text: formatMessage("Checkin"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  const renderTabTitle = (img, title, badge, path) => {
    return (
      <div className="dashboard-tab-content">
        <div className="info">
          <img src={`/assets/images/` + img} alt="" className="icon" />
          <div className="title">
            <span>{formatMessage(title)}</span>
            <Link to={path}>
              {formatMessage("SeeAll")} <i className="dx-icon-chevronright"></i>
            </Link>
          </div>
        </div>
        <div className="badge">{badge}</div>
      </div>
    );
  };

  return (
    <div>
      {popupConfig.popupVisible && renderViewPopup()}
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("Approval")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/" className={"breadcrumb-item"}>
            {formatMessage("Approval")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("ApprovalSetting")}
          </span>
        </div>
      </div>

      {MIDDLE && MIDDLE.ApproveState && (
        <div className={"section"}>
          <div className={"section-body p-0"}>
            <TabPanel className="tab-approval">
              <Item
                onClick={() => history.push("/overtime/overtime-approval/list")}
                tabComponent={() =>
                  renderTabTitle(
                    "info-1.png",
                    "OvertimeApproval",
                    count?.Overtime,
                    "/overtime/overtime-approval/list"
                  )
                }
              />
              <Item
                onClick={() => history.push("/leave/leave-approval/list")}
                tabComponent={() =>
                  renderTabTitle(
                    "info-2.png",
                    "LeaveApproval",
                    count?.Leave,
                    "/leave/leave-approval/list"
                  )
                }
              />
              <Item
                onClick={() =>
                  history.push(
                    "/transactions/transactions-adjustment-approval/list"
                  )
                }
                tabComponent={() =>
                  renderTabTitle(
                    "info-3.png",
                    "AdjustmentApproval",
                    count?.Transaction,
                    "/transactions/transactions-adjustment-approval/list"
                  )
                }
              />
            </TabPanel>
          </div>
        </div>
      )}

      <div className={"section"}>
        <div className={"section-heading"}>
          <h4 className={"section-title"}>{formatMessage("MyInfo")}</h4>
        </div>
        <div className={"section-body p-0 bg-transparent"}>
          <div className={"card-my-info"}>
            <Link
              to="/default/personal-information"
              style={{ textDecoration: "none" }}
              className={"card"}
            >
              <img src="/assets/icons/person.svg" alt="" className="icon" />
              <span>{formatMessage("MyInfo")}</span>
            </Link>
            {user?.IsAllowRegOvt !== "False" && (
              <Link
                to="/overtime/overtime-registration/create"
                style={{ textDecoration: "none" }}
                className={"card"}
              >
                {/* <div className="card"> */}
                <img src="/assets/images/info-1.png" alt="" className="icon" />
                <span>{formatMessage("OvertimeRegistration")}</span>
                {/* </div> */}
              </Link>
            )}
            <Link
              to="/leave/leave-registration/create"
              style={{ textDecoration: "none" }}
              className={"card"}
            >
              <img src="/assets/images/info-2.png" alt="" className="icon" />
              <span>{formatMessage("LeaveRegistration")}</span>
            </Link>

            <Link
              to="/default/payslip/list"
              style={{ textDecoration: "none" }}
              className={"card"}
            >
              <img src="/assets/images/info-4.png" alt="" className="icon" />
              <span>{formatMessage("ViewPaySlips")}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
